module.exports = __webpack_public_path__ + "img/cart_leading-brands.c7cbd9f8.png";